export default "__VITE_ASSET__CZvMvobG__"